import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import moment from "moment";
import {
  CheckIcon,
  EditIcon,
  EmailIcon,
  PaymentIcon,
} from "@shopify/polaris-icons";

const Users = () => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddUser = () => {
    navigate("/admin/settings/users-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "ID", value: "id" },
            { label: "Name", value: "name" },
            { label: "Email", value: "email" },
            { label: "Phone Number", value: "phone_number" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };

  const handleClickRow = (param) => {
    //  navigate(`/admin/users/${param}`);
    window.open(`/admin/users/${param}`, "_blank");
  };
  const handleEdit = (param) => {
    //navigate(`/admin/users/${param}/edit`);
    window.open(`/admin/users/${param}/edit`, "_blank");
  };
  const handlePayments = (param) => {
    navigate(`/admin/users/${param}/payments`);
  };
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page]);

  async function fetchData() {
    let responseUsers = "";
    let responseFeatures = [];

    try {
      responseUsers = await axios.get(
        `/app/users?per_page=${perPage}&page=${refBoolPage.current ? page : 1}${
          queryValue
            ? `&filter[${
                availability === "" ? "name" : availability
              }]=${queryValue}`
            : ""
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: responseUsers.data.data.data.map((item, index) => [
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.id}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.first_name ? item?.first_name : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.last_name ? item?.last_name : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.email ? item?.email : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.birthday ? item.birthday : "-"}
          </div>,

          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            <Badge tone={item?.access_type === "0" ? "default" : "info"}>
              {item?.access_type === "0" ? "Customer" : "Instructor"}
            </Badge>
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.created_at
              ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.phone_number ? item?.phone_number : "-"}
          </div>,

          <ButtonGroup>
            {/* <Button onClick={() => handlePayments(item.id)}>Reviews</Button>
            <Button onClick={() => handlePayments(item.id)}>Bookings</Button> */}
            <Button icon={PaymentIcon} onClick={() => handlePayments(item.id)}>
              Payments
            </Button>
            <Button icon={EditIcon} onClick={() => handleEdit(item.id)}>
              Edit
            </Button>
            <Button
              onClick={() => {
                refId.current = item.id;
                setActiveVerify(true);
              }}
              disabled={item?.email_verified_at}
              icon={EmailIcon}
            >
              Verify Email
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !responseUsers.data.data.data.length ? true : false,
        tableTotalPages: responseUsers.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This user has been successfully verified"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const refId = useRef(null);
  const [activeVerify, setActiveVerify] = useState(false);
  const handleChangeModalVerify = useCallback((activeVerify) => {
    setActiveVerify(!activeVerify);
    setIsSaving(false);
  }, []);
  const handleYesVerify = () => {
    setIsSaving(true);
    axios
      .post(`/app/users/${refId.current}/verify`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveVerify(!activeVerify);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title="Users"
      fullWidth
      // primaryAction={
      //   <Button variant="primary" onClick={handleAddUser}>
      //     Add User
      //   </Button>
      // }
    >
      <Card padding="0">
        {loadingMarkup}

        <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        />

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              First Name
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Last Name
            </Text>,

            <Text variant="bodyMd" as="p" fontWeight="medium">
              Email
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Date of Birth
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Type
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Created at
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Phone Number
            </Text>,

            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Is email verified?
            // </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
          // truncate
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        <Modal
          open={activeVerify}
          onClose={handleChangeModalVerify}
          title="Verify User"
          primaryAction={{
            content: "Yes",
            onAction: handleYesVerify,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalVerify,
            },
          ]}
        >
          <Modal.Section>
            <Text>
              <p>Are you sure you want to verify this user?</p>
            </Text>
          </Modal.Section>
        </Modal>
        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default Users;
